import { type ReactNode, useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { convertCreatorsToCSV, downloadCSV } from '../utils/csv-export';
import { fetchAllValidCreators } from '../utils/csv-export-fetch';
import { useToast } from '@/components/ui/toast';

async function exportAll(
  toast: (m: string, t: 'success' | 'error') => void
): Promise<void> {
  const all = await fetchAllValidCreators();
  const csv = convertCreatorsToCSV(all);
  downloadCSV(csv, `creators-${new Date().toISOString().slice(0, 10)}.csv`);
  toast(`${all.length} creadores exportados`, 'success');
}

function ExportIcon({ loading }: { loading: boolean }): ReactNode {
  return loading ? (
    <Loader2 size={13} className="animate-spin" />
  ) : (
    <Download size={13} />
  );
}

export function CsvExportButton(): ReactNode {
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();

  async function handle(): Promise<void> {
    setLoading(true);
    try {
      await exportAll(toast);
    } catch {
      toast('Error al exportar', 'error');
    } finally {
      setLoading(false);
    }
  }

  return (
    <button
      onClick={handle}
      disabled={loading}
      title="Exportar CSV"
      className="flex items-center gap-1 rounded-md px-2 py-1.5 text-xs text-text-tertiary transition-colors hover:bg-white/[0.04] hover:text-text-primary disabled:opacity-40"
    >
      <ExportIcon loading={loading} />
      <span>{loading ? 'Exportando…' : 'CSV'}</span>
    </button>
  );
}
